// setMessageExpanded.js
'use strict';
import { MERGE_OPERATION_DATA } from '../ActionTypes.js';
const fields = ['broadcastList', 'caption', 'input', null];

/**
 * @typedef {'broadcastList' | 'caption' | 'input'} Field
 */

/**
 * Set message expanded
 * @kind action
 * @param {Object} params
 * @param {Field} params.expandedField - the field to expand. ex: caption | broadcastList
 * @param {string} params.messageId - message id
 * @return {Promise} Action promise.
 */
const setMessageExpanded =
  ({ expandedField, messageId }) =>
  async dispatch => {
    if (!fields.includes(expandedField)) {
      return;
    }

    return dispatch({
      type: MERGE_OPERATION_DATA,
      payload: {
        selectPath: ['message', messageId],
        data: { expandedField },
      },
    });
  };

export default setMessageExpanded;
